<template>
  <div>
    <PartnerHeader :img_header="header_image" header="จัดโปรโมชั่นราคาใหม่" link_back="promotioninformation"/>
    <Promotion_add_pos_price/>
  </div>
</template>

<script>
import PartnerHeader from "@/components/admin/manage_pos/partner_store_setting/menu_partner_store/PartnerHeader";
import HeaderImage from "@/assets/process.png";
// import MenuPartner from "@/components/admin/manage_pos/partner_store_setting/menu_partner_store/MenuPartner";
import Promotion_add_pos_price from "@/components/admin/manage_pos/partner_store_setting/Promotion_add_pos_price";
export default {
  name: "PromotionAddPosFree",
  components: {
    Promotion_add_pos_price,
    PartnerHeader
  },
  data() {
    return {
      header_image: HeaderImage
    }
  }
}
</script>

<style scoped>

</style>
